import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {BillingStatus} from '../../api/types';

/**
 * `partial`: the status answers for some purchases, not for the account --
 * the POST billing/purchases response covers only the transactions it was
 * sent. It still updates the slice (as it always has), but never counts as a
 * premium lapse (#303, premiumLapseMiddleware).
 */
type BillingStatusMeta = {partial: true};

type SliceState = {
  billing: BillingStatus;
};

const initialState: SliceState = {
  billing: {
    premium: false,
    legacy_premium: false,
    purchase: null,
    free_subscription: null,
  },
};

export const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setBillingStatus: {
      reducer: (
        state,
        {
          payload: billing,
        }: PayloadAction<BillingStatus, string, BillingStatusMeta | undefined>,
      ) => {
        state.billing = billing;
      },
      prepare: (billing: BillingStatus, meta?: BillingStatusMeta) => ({
        payload: billing,
        meta,
      }),
    },
  },
});

export const {setBillingStatus} = billingSlice.actions;

export default billingSlice.reducer;
